import { render, staticRenderFns } from "./PaymentContainer.vue?vue&type=template&id=4b540f62&"
import script from "./PaymentContainerVue.ts?vue&type=script&lang=ts&"
export * from "./PaymentContainerVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports